/**
 * Split a typed or pasted list of email addresses.
 *
 * People paste address lists out of a spreadsheet, a mail client, a text
 * message and a meeting agenda, and each one separates them differently.
 * Splitting is all this does: whether an address is well formed is the
 * server's call (functions/src/invites/sendAudienceInvite.ts), because a
 * client-side rule that disagreed with the server's would reject addresses
 * that would have sent fine.
 */
export function parseEmailList(raw: string): string[] {
  const seen = new Set<string>();
  for (const part of raw.split(/[\s,;]+/)) {
    const email = part.trim().toLowerCase();
    if (email) seen.add(email);
  }
  return [...seen];
}
